import emilyAvatar from "../images/image-emily.jpg";
import thomasAvatar from "../images/image-thomas.jpg";
import jennieAvatar from "../images/image-jennie.jpg";

const clientTestimonials = [
  {
    name: "Emily R.",
    testimonial:
      "We put our trust in Sunnyside and they delivered, making sure our needs were met and deadlines were always hit.",
    jobTitle: "Marketing Director",
    avatar: emilyAvatar,
  },
  {
    name: "Thomas S.",
    testimonial:
      "Sunnyside’s enthusiasm coupled with their keen interest in our brand’s success made it a satisfying and enjoyable experience.",
    jobTitle: "Chief Operating Officer",
    avatar: thomasAvatar,
  },
  {
    name: "Jennie F.",
    testimonial:
      "Incredible end result! Our sales increased over 400% when we worked with Sunnyside. Highly recommended!",
    jobTitle: "Business Owner",
    avatar: jennieAvatar,
  },
];

export default clientTestimonials;
